import Vue from "vue";
import axios from "axios";
import Qs from "qs";
import wx from "weixin-js-sdk";

export const busEvent = new Vue();
export function overlap(dom1, dom2) {
  const rect1 = dom1.getBoundingClientRect();
  const rect2 = dom2.getBoundingClientRect();

  const x1 = rect1.x || rect1.left;
  const y1 = rect1.y || rect1.top;
  const w1 = rect1.width;
  const h1 = rect1.height;

  const x2 = rect2.x || rect2.left;
  const y2 = rect2.y || rect2.top;
  const w2 = rect2.width;
  const h2 = rect2.height;

  return x1 + w1 > x2 && x1 < x2 + w2 && y1 + h1 > y2 && y1 < y2 + h2;
}

export function getGUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// 获取url中参数
export function getQueryString(name, url) {
  var after = url ? url.split("?")[1] : window.location.hash.split("?")[1];
  if (after) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = after.match(reg);
    if (r != null) {
      return decodeURIComponent(r[2]);
    } else {
      return null;
    }
  }
}

export function wxShare({ title, desc, link, imgUrl } = {}) {
  var ua = navigator.userAgent.toLowerCase();
  var url = "index.php/mobile/index/get-wx-js-api-config";
  var isWeixin = ua.match(/micromessenger/i) == "micromessenger";
  const companyCode = location.origin.split(".")[0].split("//")[1];
  // 登录状态
  if (
    isWeixin &&
    localStorage._user_data_sso_token &&
    localStorage._user_data_id &&
    localStorage._username
  ) {
    console.log('url:', location.href, location.href.split('#')[0])
    let params = null;
    if (ua.match(/wxwork/i) == "wxwork") {
      // 企业微信
      params = {
        company_code:
          process.env.VUE_APP_MODE === "local" ? "intest" : companyCode,
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),
        client_version: localStorage.getItem("client_version") || "1.2.0",
        department_id: localStorage.getItem("_user_data_department_id"),
        url: location.href.split("#")[0],
      };
    } else {
      // 微信
      url = "index.php/mobile/index/get-wxopen-js-api-config";
      params = {
        company_code:
          process.env.VUE_APP_MODE === "local" ? "intest" : companyCode,
        url: location.href.split("#")[0],
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
      };
    }

    axios({
      url: url,
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify(params),
    }).then(function (data) {
      let json = data.data;
      if (json.code == 0) {
        // console.log('appId:', json.result.appId)
        wx.config({
          // beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId:
            ua.match(/wxwork/i) == "wxwork"
              ? json.result.corpid
              : json.result.appId, // 必填，企业微信的corpID
          timestamp: json.result.timestamp, // 必填，生成签名的时间戳
          nonceStr: json.result.nonceStr, // 必填，生成签名的随机串
          signature: json.result.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
          jsApiList: [
            "onMenuShareAppMessage",
            "onMenuShareWechat",
            "onMenuShareTimeline",
            "updateAppMessageShareData",
            "updateTimelineShareData",
          ], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        });
      }

      wx.ready(function () {
        var shareData = {
          title: title,
          desc: desc || " ",
          imgUrl: imgUrl,
          link: link,
        };
        if (wx.updateAppMessageShareData) {
          //1.4 分享到朋友
          //微信文档中提到这两个接口即将弃用，故判断
          wx.updateAppMessageShareData(shareData);
        }
        if (wx.updateTimelineShareData) {
          //1.4分享到朋友圈
          wx.updateTimelineShareData(shareData);
        }
        if (wx.onMenuShareAppMessage) {
          wx.onMenuShareAppMessage(shareData); // 获取“转发”按钮点击状态及自定义分享内容接口
        }
        if (wx.onMenuShareWechat) {
          wx.onMenuShareWechat(shareData); // 获取“微信”按钮点击状态及自定义分享内容接口
        }
        if (wx.onMenuShareTimeline) {
          wx.onMenuShareTimeline(shareData); // 分享到朋友圈
        }
      });

      wx.error(() => {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        // console.log('error:', res)
      });
    });
  }
}

// 当前平台是-1学习平台/0企业微信/1企业微信代开发
export function isQYWXTPI() {
  localStorage.setItem("is_custom_app", '');
  return new Promise((resolve, reject) => {
    const companyCode = location.origin.split('.')[0].split('//')[1]
    const url = "index.php/mobile/qywx/qywx-is-custom-app"
    let params = {
      company_code: process.env.VUE_APP_MODE === "local" ? "intest" : companyCode,
    };
    axios({
      url: url,
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify(params),
    }).then((res) => {
      if (res.data.code == 0) {
        localStorage.setItem("is_custom_app", res.data.result.is_custom_app)
        resolve(res.data.result.is_custom_app)
      } else {
        reject()
      }
    });
  });
}

// 在fetch中调用
export function replaceBy(router, is_custom_app) { 
  if (navigator.userAgent.toLowerCase().match(/wxwork/i) == "wxwork" && parseInt(is_custom_app) === 1) {
    // alert('fetch中企业代开发模式:' + is_custom_app)
    let companyCode = process.env.VUE_APP_MODE === "local" ? "intest" : location.origin.split(".")[0].split("//")[1];
    let tpiPath = `${process.env.VUE_APP_TPI_PATH}?companyCode=${companyCode}&bigJump=${encodeURIComponent(window.location.href)}`
    location.replace(tpiPath)
    return
  } else if (navigator.userAgent.toLowerCase().match(/wxwork/i) == "wxwork" && parseInt(is_custom_app) === 0) {
    // alert('fetch中企业微信:' + is_custom_app)
    router.replace({
      name: "weixinLogin",
      query: {
        smallJump: encodeURIComponent(window.location.href)
      },
    });
    return
  } else if (navigator.userAgent.toLowerCase().match(/wxwork/i) == "wxwork" && parseInt(is_custom_app) === -1) {
    // alert('fetch中普通学习平台-1-1-1:' + is_custom_app)
    router.replace({
      name: "Login",
    });
    return
  } else {
    // alert('fetch中普通学习平台:' + is_custom_app)
    router.replace({
      name: "Login",
    });
  }
}


let _scrollTop;
class ModalHelper {
  // popup 显示时调用
  static afterOpen() {
    _scrollTop = document.scrollingElement.scrollTop;
    document.body.style.position = "fixed";
    document.body.style.top = -_scrollTop + "px";
  }

  // popup 关闭时调用
  static beforeClose() {
    document.body.style.position = "";
    document.body.style.top = "";
    // 使 scrollTop 恢复原状
    document.scrollingElement.scrollTop = _scrollTop;
  }
}

export default ModalHelper;